import { tableFormat } from 'src/constants/constants';
import { dayWorker } from 'src/utils';

export const useDateFormatter = () => {
    return (date_: string | number, format: string = tableFormat): string => {
        return dayWorker(date_).format(format);
    };
};
